<script setup lang="ts">
import { ContextInput, LanguageType } from '@/__generated__/gateway/graphql';
import { useCommunityTranslations } from '@/shared/composables/community/translations';
import { getLanguageType } from '@/shared/utils/gateway/helpers';

import PostList from './PostList.vue';

const context: ContextInput = {
  language: getLanguageType(window.Shopify.locale, LanguageType.En)
};

const communityTranslations = useCommunityTranslations('GlobalFeed');
</script>

<template>
  <div class="flex justify-center">
    <div class="mx-auto w-full max-w-3xl px-4">
      <div class="mb-4">
        <h1 class="pb-6 pt-5 text-3xl font-bold">Community</h1>
      </div>
      <PostList
        :context="context"
        :show-teasers="true"
        :community-translations="communityTranslations"
      />
    </div>
  </div>
</template>
